const ViewsFactory = require('public_framework/views_factory')

const Components = {
  Shared: {
    SocialShare: require('public_shared_components').SocialShare
  },
  SortingAlgorithms: {
    Animation: require('./views/animation'),
    Code: require('./views/code')
  }
}

ViewsFactory.addComponents(Components)



// WEBPACK FOOTER //
// ./front/apps/public/pages/sorting_algorithms/javascripts/index.js